import React from 'react';
import { NavLink } from 'react-router-dom';
import { Map as MapIcon, Gem, TrendingUp, Feather, CalendarDays, FlaskConical, Store } from 'lucide-react';
export const explorerLinks = [{
  to: '/guia/evoluciones',
  label: 'Evoluciones y misiones',
  desc: 'Sebina, Marlon, combo y tercera evolución por clase.',
  icon: TrendingUp
}, {
  to: '/guia/alas',
  label: 'Alas y capas',
  desc: 'Recetas de la Chaos Machine paso a paso.',
  icon: Feather
}, {
  to: '/guia/combinaciones',
  label: 'Mascotas y combinaciones',
  desc: 'Dark Horse, Dark Raven, Dinorant, Fenrir y entradas de eventos.',
  icon: FlaskConical
}, {
  to: '/guia/mapas',
  label: 'Mapas, monstruos y spots',
  desc: 'Coordenadas, áreas, accesos por nivel y apariciones de invasión.',
  icon: MapIcon
}, {
  to: '/guia/items',
  label: 'Ítems y drops',
  desc: 'De dónde sale cada ítem: monstruo, evento o caja.',
  icon: Gem
}, {
  to: '/guia/eventos',
  label: 'Eventos',
  desc: 'Horarios configurados, salas por nivel y recompensas.',
  icon: CalendarDays
}, {
  to: '/guia/npc',
  label: 'NPC y tiendas',
  desc: 'Dónde está cada NPC, qué servicio presta y qué vende.',
  icon: Store
}];

/** Accesos a las guías interactivas y exploradores, compartidos por la barra lateral y el menú móvil. */
export function ExplorerNavLinks({
  size = 'sm'
}: {
  size?: 'sm' | 'lg';
}) {
  return <ul className="space-y-0.5" data-id="element-384" data-mp="160du0kxins1f">
      {explorerLinks.map(({
      to,
      label,
      icon: Icon
    }) => <li key={to} data-id="element-385" data-mp="1toosxijnjhn2">
          <NavLink to={to} className={({
        isActive
      }) => `flex items-center gap-2.5 rounded-xl px-3 ${size === 'lg' ? 'py-3' : 'py-2'} text-sm transition-colors duration-150 ${isActive ? 'bg-white/[0.06] text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-386" data-mp="1tpgo4s9c7dct">
            <Icon className="h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-387" data-mp="1ow3yqfwu32j0" />
            {label}
          </NavLink>
        </li>)}
    </ul>;
}